const api = 'http://lalielandryapi'

const config = {
  siteName: 'Lalie Landry',
  apiBaseUrl: api,
  slideImageBaseUrl: api + '/upload/slides/',
  serieImageBaseUrl: api + '/upload/series/',
  novelImageBaseUrl: api + '/upload/novels/',
  eventImageBaseUrl: api + '/upload/events/',
  productImageBaseUrl: api + '/upload/products/',
  contactEmail: 'lalie@lalie-landry.com',
  contactMail: 'Au-delà du miroir éditions, 110 avenue de Clichy 75017 Paris, à l\'attention de Lalie Landry',
  bddTrueValue: "1",
  bddFalseValue: "0",
  stripePublicKey: "pk_test_51SH1273DrfSe3HS4xWHchiv4cb37SK5R7kHSyaIlcHFuO1iuHZjVczeVPBpokgC5aPxDzybM59NzekJTNyFTzokR00itIbnJQ8",
}

export default config